export const CODE_PACKAGE_FORM_NAME = "code";
export const ROLE_OPERATEUR_FORM_NAME = "roleOperateurId";
export const STATUS_PACKAGE_FORM_NAME = "statut";
export const TYPE_PAIEMENT_FORM_NAME = "typePaiment";
export const TRANSACTION_AUTORISEE_FORM_NAME = "typeTransactionAutorisee";
export const NOMBRE_TRANSACTIONS_FORM_NAME = "nbrTransaction";
export const TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME = "typeFraisService";
export const ID_IMPORTATEUR   = "importateur";
export const ID_BANQIE   = "banque";
export const ID_APR   = "autoritePortuaire";
export const ID_OPM   = "idOpm";
export const ID_TRANSITAIRE   = "idTransitaire";
export const ID_CONSIGNATAIRE   = "idConsignataire";